const Events = [
  {
    id: 1,
    title: "Session to resolve all doubts regarding the different career opportunities and how to prepare for them",
    quote:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    createdAt: "June 03, 2021",
    image: "/assets/images/cos.jpg",
  },
  {
    id: 2,
    title: "Connects students with a senior who is their guide though the college",
    quote: "Connects students with a senior who is their guide though the college.",
    createdAt: "June 03, 2021",
    image: "/assets/images/smp.jpg",
  },
  {
    id: 3,
    title: "Sessions where PDS mentors not just clear concepts and doubts but provide practice as well",
    quote:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    createdAt: "June 03, 2021",
    image: "/assets/images/pds.jpg",
  },
  {
    id: 4,
    title: "One stop solution for all academic, non academic and CDC doubts!",
    quote: "One stop solution for all academic, non academic and cdc doubts!!",
    name: "SWG App",
    image: "/assets/images/app.jpg",
  },
  // {
  //   id: 5,
  //   title: 'All one can need for DepC (except for the report of working hard) is here!',
  //   quote:"All one can need for DepC (except for the report of working hard) is here!",
  //   name: 'DepC Talks',
  //   image: '/assets/images/depc.jpg',
  // },
];

export default Events;
